import BackButton from "components/Button/BackButton"
import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { DropdownRoomStatus, EmptyString, FormTypeAdd, FormTypeEdit } from "utils/Constant"
import Dropdown from "components/Input/Dropdown"
import { useModal } from "utils/context/ModalContext"
import { RoomService } from "services/RoomService"
import { MainBodyCard } from "components/Cards/MainBodyCard"
import { FormCard } from "components/Cards/FormCard"

export default function RoomSetupForm(){
    const navigate = useNavigate()

    const { showLoading, hideLoading, showSuccess, confirm } = useModal()
    
    const { fetchCreateRoom, fetchUpdateRoom, fetchDeleteRoom, fetchRoomTypeList, fetchRoomById } = RoomService()

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramRoomId = queryString.get("roomId")

    const [roomNumber, setRoomNumber] = useState(EmptyString)
    const [roomTypeOptions, setRoomTypeOptions] = useState(EmptyString)
    const [roomTypeId, setRoomTypeId] = useState(EmptyString)
    const [roomStatus, setRoomStatus] = useState(EmptyString)
    
    const getRoomById = async () => {
        const res = await fetchRoomById(paramRoomId)
        if (!res) return

        const data = res.data

        setRoomNumber(data.roomNumber)
        setRoomTypeId(String(data.roomTypeId))
        setRoomStatus(data.roomStatus)
    }
    const getRoomTypeList = async () => {
        const res = await fetchRoomTypeList('', 100, 0)
        if (!res) return

        const data = res.data.listData

        const options = data.map((item) => ({ label: item.roomTypeName, value: String(item.roomTypeId) }))

        setRoomTypeOptions(options)
    }

    const saveBtnClick = async () => {
        if (!validateForm()) return
        
        const onConfirm = await confirm()
        if (!onConfirm) return

        try {
            showLoading()

            if (formType === FormTypeAdd){
                const res = await fetchCreateRoom(
                    roomNumber,
                    roomTypeId,
                    roomStatus
                )

                if (!res) return

                showSuccess({
                    onSuccess: () => {
                        navigate('/setting/room-setup')
                    }
                })
            } else {
                const res = await fetchUpdateRoom(
                    paramRoomId,
                    roomNumber,
                    roomTypeId,
                    roomStatus
                )

                if (!res) return

                showSuccess({
                    onSuccess: () => {
                        navigate('/setting/room-setup')
                    }
                })
            }
        } finally {
            hideLoading()
        }
    }
    const deleteBtnClick = async () => {
        const onConfirm = await confirm()
        if (!onConfirm) return

        try {
            showLoading()

            const res = await fetchDeleteRoom(paramRoomId)
            if (!res) return

            showSuccess({
                onSuccess: () => {
                    navigate('/setting/room-setup')
                }
            })
        } finally {
            hideLoading()
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    function validateForm(){
        let errorCount = 0

        // if (tenantName === EmptyString){
        //     errorCount++
        //     setErrorTenantName(true)
        // }else{
        //     setErrorTenantName(false)
        // }

        

        if (errorCount > 0){
            return false
        }else{
            return true
        }
    }

    useEffect(() => {
        const onLoad = async () => {
            try {
                showLoading()

                await getRoomTypeList()

                if (formType === FormTypeEdit){
                    await getRoomById()
                }
            } finally {
                hideLoading()
            }
        }

        onLoad()
    }, [])

    return (
        <MainBodyCard>
            <div>
                <div className="flex justify-between">
                    <span className="font-semibold text-2xl">Room Detail</span>
                </div>
            </div>
            <hr />

            <div className="mt-5 flex flex-col gap-3">
                <FormCard title='Room Number'>
                    <input className="input" value={roomNumber} onChange={(e) => setRoomNumber(e.target.value)} disabled={formType === FormTypeEdit ? true : false} />
                </FormCard>

                <FormCard title='Room Type'>
                    <Dropdown options={roomTypeOptions} value={roomTypeId} onChange={(e) => setRoomTypeId(e.value)} placeholder={"Select Room Type"} />
                </FormCard>

                <FormCard title='Room Number'>
                    <Dropdown options={DropdownRoomStatus} value={roomStatus} onChange={(e) => setRoomStatus(e.value)} placeholder={"Select Room Status"} />
                </FormCard>

                <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                    <SaveButton onClick={saveBtnClick} visible={true} />
                    <DeleteButton onClick={deleteBtnClick} visible={true} />
                    <BackButton onClick={backBtnClick}  />
                </div>
            </div>
        </MainBodyCard>
    )
}